import { Component, OnInit, ChangeDetectionStrategy, Inject, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { MatDialog } from '@angular/material/dialog';
import { ENV_CONFIG } from '@core/interfaces/configs';
import { WindowService } from '@core/services/window.service';
import { ENVCONFIG } from '@core/tokens/configs';
import { OidcErrorHandlerMixin } from '@core/utils';
import { clearOIDCError } from '@store/core/core.actions';
import { selectLinkedFIIds, selectUserProfileRef } from '@store/user/user.selectors';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FiSelectionComponent } from '../../../../../core/components/fi-selection/fi-selection.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { LetDirective } from '@ngrx/component';
import { filter, Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import {UntilDestroy} from '@core/classes/untilDestroy.class';
import {FinancialInstitution, LoaderState} from '@store/core/core.interface';
import {selectFinancialInstitutions} from '@store/core/core.selectors';
import {FiSelectionService} from '@core/services/fi-selection.service';

@Component({
    selector: 'pbb-link-another-page',
    templateUrl: './link-another-page.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LetDirective, MatButtonModule, RouterLink, MatIconModule, FiSelectionComponent, TranslateModule, AsyncPipe]
})

// extend FI selection Class if selectedFI are not to be filtered
export class LinkAnotherPageComponent extends OidcErrorHandlerMixin(UntilDestroy) implements OnInit, OnDestroy {
  redirectUrl: string = '/checkout/registered/orderReview/returnUser/paymentMethod';

  userProfileRef$ = this.store.select(selectUserProfileRef);
  linkedFiIds$: Observable<string[]> = this.store.select(selectLinkedFIIds);
  financialInstitutions$: Observable<LoaderState<FinancialInstitution[]>> = this.store
      .select(selectFinancialInstitutions)
      .pipe(filter((financialInstitutions) => !!financialInstitutions));

  constructor(
    private store: Store,
    private fiSelectionService: FiSelectionService,
    private readonly router: Router
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.router.url.includes('returnUser')) {
      this.redirectUrl = '/checkout/registered/orderReview/returnUser/paymentMethod';
    } else {
      this.redirectUrl = '/checkout/registered/orderReview/paymentMethod';
    }
  }
  override ngOnDestroy(): void {
    this.store.dispatch(clearOIDCError());
    super.ngOnDestroy();
  }

  fiSelected(selectedFI: any, userProfileRef?: string): void {
    this.fiSelectionService.fiSelected(selectedFI, userProfileRef, false, this.redirectUrl, false);
  }
}
